import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';

export function useGetMultiProjectTagGroupsGq(
  command: CommandGq,
  options: QueryHookOptions<DataGq, Variables> = {}
) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    ...options,
    variables: { command },
  });

  return {
    query,
    result:
      (query?.data ?? query?.previousData)?.projects?.getMultiProjectTagGroups?.tagGroupNames ?? [],
  };
}

const gqTag = gql`
  query GetMultiProjectTagGroups($command: GetMultiProjectTagGroupsCommand!) {
    projects {
      getMultiProjectTagGroups(command: $command) {
        tagGroupNames
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getMultiProjectTagGroups: {
      readonly tagGroupNames: string[];
    };
  };
}

export interface Variables {
  command: CommandGq;
}
export interface CommandGq {
  projectId: number;
}
